const getters = {
  sidebarShow: state => state.app.sidebarShow,
  sidebarMinimize: state => state.app.sidebarMinimize,
  token: state => state.user.token,
  cart: state => state.commerce.cart,
};
export default getters;
